import { render, staticRenderFns } from "./systemNotification.vue?vue&type=template&id=626687c1&"
import script from "./systemNotification.vue?vue&type=script&lang=js&"
export * from "./systemNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports